/**
 * Vuex module for smsToEmails
 */
import debug from 'debug'
import API from '@/api'
import SmsToEmail from 'Store/class/chat/sms_to_email'
import events from 'Store/events'

const dbg = debug('store:smsToEmails:')

const actions = {
  get ({ commit, rootGetters, state }) {
    dbg('loading smsToEmails')
    return new Promise((resolve, reject) => {
      return API.getSmsToEmail().then(response => {
        commit('ADD_SMS_TO_EMAILS', response.data)
        resolve()
      }).catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get smsToEmails'
        events.pubError(msg)
        reject(err)
      })
    })
  },

  set ({ commit }, smsToEmail) {
    commit('NEW_SMS_TO_EMAIL', smsToEmail)
  },

  save ({ commit }) {
    commit('SAVE_SMS_TO_EMAILS')
  }
}

const mutations = {
  // add a new smsToEmail to the state on fetching the list from the server
  ADD_SMS_TO_EMAILS (state, data) {
    const smsToEmails = []
    data.forEach(smsToEmail => {
      smsToEmails.push(new SmsToEmail(smsToEmail))
    })
    state.smsToEmails = smsToEmails
  },

  // add or update the state of a smsToEmail record
  NEW_SMS_TO_EMAIL (state, param) {
    const index = state.smsToEmails.findIndex(smsToEmail => { return (smsToEmail.did_id === param.did_id) })
    if (index === -1) {
      const newSmsToEmail = new SmsToEmail(param)
      state.smsToEmails.push(newSmsToEmail)
    } else {
      state.smsToEmails[index] = new SmsToEmail(param)
    }
  },

  // submits the smsToEmails to the server
  SAVE_SMS_TO_EMAILS (state) {
    API.setSmsToEmail(state.smsToEmails).then(resp => {
      events.pubNotify({
        status: 'success',
        text: 'chat.smsToEmails.notify.saved'
      })
      this.dispatch('chat/SmsToEmails/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to set smsToEmails')
    })
  }
}

const state = {
  smsToEmails: []
}

const getters = {
  smsToEmails: state => state.smsToEmails
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
